// Customer Details Section
export const FORM_FIELD_EMP_CODE = "empcode";
export const FORM_FIELD_PASSWORD = "password";

export const FORM_FIELD_AADHAAR_NUMBER = "aadhaar_number";
export const FORM_FIELD_GENDER = "gender";
export const FORM_FIELD_DOB = "dob";
export const FORM_FIELD_NAME = "name";
export const FORM_FIELD_MOBILE = "mobile";
export const FORM_FIELD_STEP = "step";
export const FORM_FIELD_OTP = "otp";
export const FORM_FIELD_PINCODE = "pincode";
export const FORM_FIELD_PARTNER_ID = "partnerId";
export const FORM_FIELD_GENERATE_OTP = "generateOtp";
export const FORM_FIELD_VERIFY_OTP = "verifyOtp";
export const FORM_FIELD_HAS_ERROR = "hasError";

export const FORM_FIELD_HEIGHT = "height";
export const FORM_FIELD_WEIGHT = "weight";
export const FORM_FIELD_BMI = "bmi";
export const FORM_FIELD_HEIGHT_FEET = "heightFeet";
export const FORM_FIELD_HEIGHT_INCH = "heightInch";
export const FORM_FIELD_HEIGHT_CM = "heightCm";
export const FORM_FIELD_ANNUAL_INCOME = "annualIncome";

export const ONLY_ALPHA_NUMERIC_FIELDS = [];
export const ONLY_ALPHA_NUMERIC_SPACE_FIELDS = [];
export const ONLY_DIGIT_FIELDS = [
  FORM_FIELD_MOBILE,
  FORM_FIELD_HEIGHT,
  FORM_FIELD_HEIGHT_FEET,
  FORM_FIELD_HEIGHT_INCH,
  FORM_FIELD_HEIGHT_CM,
  FORM_FIELD_WEIGHT,
  FORM_FIELD_BMI,
  FORM_FIELD_PINCODE,
  FORM_FIELD_ANNUAL_INCOME,
];
export const FIELDS_HAVING_ALPHABET_AND_SPACE_ONLY = [FORM_FIELD_NAME];
export const FIXED_LENGTH_FIELDS = [FORM_FIELD_PINCODE];

export const RESPONSE_FIELDS = [];
export const RESPONSE_FIELDS_DATE = [];
